import { Getter } from "vuex";
import { IState } from './state';

const backgroundColor: Getter<IState, IState> = (state) => {
	if(state.backgroundColor){
		return 'background-color:' + state.backgroundColor + ';'
	} else {
		return '';
	}
};

const accentColor: Getter<IState, IState> = (state) => {
	if(state.accentColor){
		return 'color:' + state.accentColor + ';'
	} else {
		return '';
	}
};

const textColor: Getter<IState, IState> = (state) => {
	if(state.textColor){
		return 'color:' + state.textColor + ';'
	} else {
		return '';
	}
};

const blockColor: Getter<IState, IState> = (state) => {
	if(state.blockColor){
		return 'background-color:' + state.blockColor + ';'
	} else {
		return '';
	}
}

const accentBackgroundColor: Getter<IState, IState> = (state) => {
	if(state.accentColor){
		return 'background-color:' + state.accentColor + ';'
	} else {
		return '';
	}
}
const eventId: Getter<IState, IState> = (state) => {
	return state.eventId;
}

export default {
	backgroundColor,
	accentColor,
	textColor,
	blockColor,
	accentBackgroundColor,
	eventId
}
